/**
 * Email component used to get the user's email address
 * - used with account creation and can be a hidden input
 */

import PropTypes from 'prop-types';

import React from 'react';
import { TextInput } from '@paypalcorp/pp-react';

class Email extends React.Component {
    static propTypes = {
		type: PropTypes.string.isRequired,
		label: PropTypes.string,
		helpText: PropTypes.string,
		required: PropTypes.bool,
		value: PropTypes.string,
		errorMessage: PropTypes.string,
		changeEmail: PropTypes.func,
		handleFocus: PropTypes.func,
		handleBlur: PropTypes.func,
	};

    static defaultProps = {
        type: 'email',
        handleFocus: () => {},
        handleBlur: () => {},
    };

    state = { showIsRequiredError: false };

    /**
	 * Handle changing the email
	 * Calls parent's handler
	 * @param {String} email - the user's email
	 */
    handleChangeEmail = (email) => {
		this.handleCheckForValue(email);
		this.props.changeEmail(email);
		return email;
	};

    /**
	 * Check for an email value
	 * If the field is required, we should show that this field needs a value
	 * @param {String} email - user's email
	 */
    handleCheckForValue = (email) => {
		this.setState({ showIsRequiredError: this.props.required && !email });
	};

    /**
	 * Call parent's handleFocus
	 * @param {String} email - user's email
	 */
    handleFocus = (email) => {
		this.props.handleFocus(email);
	};

    /**
	 * Check for an email value and call parent's handleBlur
	 * @param {String} email - user's email
	 */
    handleBlur = (email) => {
		this.handleCheckForValue(email);
		this.props.handleBlur(email);
	};

    render() {
		let { value: initialValue } = this.props;

		return (
			<div style={{ margin: '10px 0 0', position: 'relative' }}>
				<TextInput
					type={this.props.type}
					name="email"
					id="email"
					label={this.props.label}
					helperText={this.props.helpText}
					required={this.props.required}
					value={initialValue}
					errorText={this.props.errorMessage}
					onChange={(event) => this.handleChangeEmail(event.target.value)}
					onFocus={(event) => this.handleFocus(event.target.value)}
					onBlur={(event) => this.handleBlur(event.target.value)}
				/>
			</div>
		);
	}
}

export default Email;
